import _ from "lodash/fp";
import React from "react";
import {connect} from "react-redux";
import {Button, ControlLabel, FormControl, FormGroup, Modal} from "react-bootstrap";
import {fetchTemplates} from "../../../stores/templates/fetchTemplates";
import {Consumer} from "../CreateSigntask";
import {isFilled} from "../../../utilities/isfilled";

const SelectTemplate = connect(
  data => ({
    templates: data.templates
  }),
  dispatch => ({
    fetchTemplates: () => dispatch(fetchTemplates())
  }),
  null,
  { withRef: true }
)(class extends React.Component {
  state = {
    show: false
  };

  componentDidMount = () => {
    this.props.fetchTemplates(); // TODO: Skip if already loaded
  };

  hasTemplates = () => _.values(this.props.templates).length > 0;
  show = () => this.setState({show: true});
  dismiss = () => this.setState({show: false});

  selectTemplate = () => {
    const name = this.selector.value;
    const template = this.props.templates[name];
    const data = this.props.getData();

    const documents = _(data)
      .takeWhile(isFilled("title", "content"))
      .union(template.documents)
      .value();
    this.props.updateDocuments(documents);

    const signers = _(data)
      .takeWhile(isFilled("name", "ssn", "email", "phone"))
      .union(template.signers)
      .value();
    this.props.updateSigners(signers);

    this.dismiss();
  };

  render = () => (
    <Modal show={this.state.show} onHide={this.dismiss}>
      <Modal.Header closeButton>
        <Modal.Title>Select template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>Select</ControlLabel>
          <FormControl componentClass="select" inputRef={element => this.selector = element}>
            {_.map(name => <option key={name} value={name}>{name}</option>, _.keys(this.props.templates))}
          </FormControl>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.dismiss}>Close</Button>
        <Button bsStyle="primary" onClick={this.selectTemplate} disabled={!this.hasTemplates()}>Use</Button>
      </Modal.Footer>
    </Modal>
  )
});

export default class extends React.Component {
  component = React.createRef();
  show = () => this.component.current.getWrappedInstance().show();
  render = () => (
    <Consumer>{({getData, updateDocuments, updateSigners}) => (
      <SelectTemplate
        ref={this.component}
        getData={getData}
        updateDocuments={updateDocuments}
        updateSigners={updateSigners}
        {...this.props} />
    )}</Consumer>
  );
}